import React, { FC, useEffect, useMemo } from 'react';
import { CourseViewType } from 'src/state/courseListing/courseListingReducer';
import { useDispatch, useSelector } from 'react-redux';
import {
  courseListingQueryFiltersSelector,
  courseListingTotalSelector,
} from 'src/state/courseListing/courseListingSelectors';
import { isEmpty, map } from 'ramda';
import { useOnlineCourseList } from 'src/common/hooks/useOnlineCourseList';
import { mapToCourseExcerpt } from 'src/common/models/event';
import { courseViewTypeInfoMapper } from 'src/public/components/course-listing/course-listing-config';
import { courseListingActions } from 'src/state/courseListing/courseListingActions';
import { CourseListingSectionDisplay } from 'src/public/components/course-listing/CourseListingAllCoursesList/CourseListingSectionDisplay';
import { firstPageNmb, firstRequestSize } from 'src/config/listing';

export const CourseListingOnlineSection: FC = () => {
  const filters = useSelector(courseListingQueryFiltersSelector);
  const dispatch = useDispatch();
  const courseTypeItem = courseViewTypeInfoMapper[CourseViewType.Online];
  const totalOnlineCourses = useSelector(courseListingTotalSelector);

  const { data, isFetching } = useOnlineCourseList(filters, firstPageNmb, firstRequestSize);

  const noPageData = useMemo(() => isEmpty(data?.result), [data]);

  const onlineCoursesData = useMemo(() => {
    if (data && data.result) {
      return map(mapToCourseExcerpt, data.result);
    }
  }, [data]);

  useEffect(() => {
    if (data && data.result) {
      dispatch(courseListingActions.setTotalOnlineCourses(data.totalResult));
    }
  }, [data, dispatch]);

  return (
    <CourseListingSectionDisplay
      totalCourses={totalOnlineCourses}
      noPageData={noPageData}
      isLoading={isFetching}
      coursesData={onlineCoursesData}
      sectionTitle={courseTypeItem?.title ?? ''}
      sectionDescription={courseTypeItem?.description}
      courseType={CourseViewType.Online}
    />
  );
};
